import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { routes } from "@/app/routes"
import { ThemeProvider } from "@/app/components/ThemeContext"
import "@/styles/tailwind.css"

const clientId = document.querySelector<HTMLMetaElement>('meta[name="client-id"]')?.content ?? ""
const router = createBrowserRouter(routes, { basename: `/${clientId}` })
const queryClient = new QueryClient()

const root = document.getElementById("root")!
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
)
